<script>
    // let bgColor = getColorFromName(colorName);
    export let colorName;

    function getColorFromName(colorName){
        switch (colorName) {
            case 'vert': return 'bg-green-700';
            case 'noir': return 'bg-yellow-900';
            case 'rooibos': return 'bg-red-700';
            case 'blanc': return 'bg-gray-300';
            case 'oolong': return 'bg-gray-300';
            case 'puerh': return 'bg-yellow-400';
            case 'infusion': return 'bg-green-400';
            default:return '';
        }
    }
</script>
<div class="flex flex-row items-center">
    <span
    class="text-center rounded-full w-3 h-3 mr-2 self-center flex justify-center {getColorFromName(colorName)}"
    ></span><span class="capitalize">{colorName}</span>
</div>